
import state from './../../zviz2/zviz/state';
import {default as Link, Controller as LinkController} from './../../zviz2/zviz/components/link';
import TextBox from './../../zviz2/zviz/components/textbox';
import Group from './../../zviz2/zviz/components/group';
import config from './../../config';
import {styleText} from './../../styles';
import {extend, cloneObject} from './../../zviz2/zviz/functions';

import DetailsBlueprint from './details';
import detailsModel from './../../model/details';

class Controller extends LinkController{

    constructor(parent, blueprint={}){
        super(parent, blueprint);        
    }


    getValue(col){
        let result = '';
        let column = this.parent.data.columns[col] || false;
        if(column){
            result = this.parent.data[column] || '';
            if(! this.showId(column)){
                return '';
            }
            if(col == 0 && state.get('renderSize') == 'small'){
                return '';
            }
        }
        let limit = (col > 1)? 45: 150;
        if(result.length > limit){
            result = result.substring(0, limit) + '...';
        }
        if(result == '__EMPTY__'){
            result = '-';
        }

        if(col === 1){
            // show the project symbol below the title
            let content = [
                extend({
                    properties: {
                        style: {display: 'block'},
                        content: result
                    }
                }, TextBox)
            ];
            const symbols = (this.parent.data['tc_symbol'] || []);
            symbols.forEach((symbol, i) => {
                content.push(
                    extend({
                        properties: {
                            style: {
                                color: '#5A7990',
                                fontStyle: 'italic',
                                marginRight: '5px'
                            },
                            content: symbol + (symbols.length > i + 1 ? ';' : '')
                        }
                    }, TextBox)
                );
            });
            result = content;
        }

        return result;
    }

    showId(column){
        if(column === 0){
            column = this.parent.data.columns[column] || false;
            if(state.get('renderSize') == 'small'){
                return false;
            }
        }
        let noIds = ['ll_id', 'gp_id', 'rec_id'];
        return (noIds.indexOf(column) == -1);
    }

    onClick(){
        if(this.parent.data.details){
            state.set('list.details_id', null);
            return;
        }
        
        let field = this.models['details'].getCountField();
        this.parent.data.details = false;

        state.set('list.details_id', this.parent.data[field]);
    }


} 

let getDetails = function(ctrl){
    if(ctrl.data.details === false){
        return [];
    }

    return extend({
        properties: { data: ctrl.data.details }
    }, DetailsBlueprint);

}



let Blueprint = extend({
    properties: {  },
    children: [
        (parent) => (extend({
            type: Controller,
            models: {
                'details': null
            },

            properties: {
                style: {
                    borderTop: '1px solid #d3d3d3',
                    display: 'block',
                    backgroundColor: (ctrl) => ( (ctrl.parent.data.index % 2 == 1)? 'white': '#f9f9f9' ),
                    padding: '10px 0px' 
                },
                data: {
                    pD: cloneObject(parent.data)
                }
            },
            events: {
                click: (event, ctrl) => ( ctrl.onClick() ) 
            },
            children: [ 
                extend({
                    properties: {
                        style: { 
                            display: 'inline-block',
                            width: (ctrl) => ( (state.get('renderSize') == 'small')? '10%' : '5%'),
                            verticalAlign: 'top',
                            textAlign: 'center'
                        },
                        data: {
                            pD: cloneObject(parent.data)
                        }
                    },
                    children: [
                        extend({
                            properties: {
                                style: {
                                    display: 'inline-block',
                                    verticalAlign: 'top',
                                    width: '20px',
                                    height: '20px',
                                    fontSize: '16px',
                                    color: 'white',
                                    backgroundColor: '#1E2DBE',
                                    borderRadius: '3px'
                                },
                                content: (ctrl) => ( ctrl.parent.parent.parent.data.details? '-': '+' )
                            }
                        }, TextBox)
                    ]
                }, TextBox),
                
                extend({
                    properties: {
                        style: extend({
                            display: 'inline-block',
                            width: (ctrl) => ( ctrl.parent.showId(0)? '15%': '0%'),
                            verticalAlign: 'top',
                            fontSize: '9pt'
                        }, styleText),
                        content: (ctrl) => ( ctrl.parent.getValue(0) )
                    }
                }, TextBox),
                
                extend({
                    properties: {
                        style: extend({
                            display: 'inline-block',
                            width: (ctrl) => ( ctrl.parent.showId(0)? '69%': ((state.get('renderSize') == 'small')? '79%': '84%') ),
                            verticalAlign: 'top',
                            fontStyle: 'italic'
                        }, styleText),
                    },
                    children: [(ctrl) => ( ctrl.parent.getValue(1) )]
                }, TextBox),
                
                extend({
                    properties: {
                        style: extend({
                            display: 'inline-block',
                            width: '10%',
                            verticalAlign: 'top',
                            fontSize: '9pt',
                            textAlign: 'center'
                        }, styleText),
                        content: (ctrl) => ( ctrl.parent.getValue(2) )
                    }
                }, TextBox),

            ]
        }, Link) ),

        (ctrl) => ( getDetails(ctrl) ) 
    ]

}, Group);


export default Blueprint;
export {Controller, Blueprint};

